<template>
  <div>
    <div class="appt-cap1 t-bold mb-3">2. Select Coupon</div>
    <div
      class="coupons-ctr"
      ref="affiliateCoupons"
      v-if="allCoupons.length > 0"
    >
      <div
        class="coupon-ctr"
        v-for="coupon in allCoupons"
        :key="coupon.id"
        :class="{ active: couponActive(coupon) }"
        @click="setSelectedCoupon(coupon)"
      >
        <input
          type="radio"
          name=""
          id=""
          v-bind:checked="couponActive(coupon)"
        />
        <img
          :src="coupon.remote_image.file_url"
          class="coupon-image"
          :class="{ active: couponActive(coupon) }"
        />
        <div>
          <p class="alt-txt">
            {{ coupon.offer_red_text.toLowerCase() }}
            {{ coupon.offer_text_top.toLowerCase() }}
            {{ coupon.offer_subline.toLowerCase() }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="spinners">
      <b-spinner class="spinner" />
      <b-spinner class="spinner" />
      <b-spinner class="spinner" />
    </div>
    <div class="goto-next">
      <div class="btn-back c-pointer" @click="back">Back</div>
      <div
        class="btn-next add-next ml-auto new-locator-next"
        @click="next"
        v-if="isVisible"
        :class="{ 'active c-pointer': selected_coupon !== null }"
      >
        Next
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AffiliateCoupons",
  data: () => {
    return {
      windowWidth: window.innerWidth,
      isVisible: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.checkVisibility);
    this.checkVisibility();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.checkVisibility);

    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    checkVisibility() {
      const element = this.$refs.affiliateCoupons;
      const rect = element.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      this.isVisible = rect.top <= windowHeight && rect.bottom >= 0;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setSelectedCoupon: function (coupon) {
      if (coupon != this.selectedCoupon()) {
        this.$store.commit("setSelectedCoupon", coupon);
      } else {
        this.$store.commit("setSelectedCoupon", null);
      }
    },
    next: function () {
      if (this.selected_coupon !== null) {
        this.$emit("next");
      }
    },
    back: function () {
      this.$emit("back");
    },
    selectedCoupon() {
      return this.$store.state.coupons.selectedCoupon;
    },
    couponActive(coupon) {
      if (!this.pageHasCoupons) {
        return false;
      }
      if (this.selected_coupon == null) {
        return false;
      } else {
        if (coupon.id === this.selected_coupon.id) {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    allCoupons() {
      return this.$store.state.coupons.allCoupons;
    },
    selected_coupon() {
      return this.$store.state.coupons.selectedCoupon;
    },
    pageHasCoupons() {
      if (this.allCoupons.length > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.alt-txt {
  font-size: medium;
  font-weight: 500;
  text-transform: capitalize;
  margin: 0;

  /* padding-inline: ; */
}

@media screen and (max-width: 768px) {
  .alt-txt {
    font-size: 0.8rem;
  }
}

.spinners {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-block: 20%;
}
.spinner {
  width: 5rem;
  height: 5rem;
}
.hdr {
  display: flex;
  align-self: center;
  font-size: 30px;
  font-weight: 800;
}
.coupons-ctr {
  display: flex;
  width: 100%;
  gap: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.coupon-image {
  width: 95%;
  height: 100%;
  cursor: pointer;
  transition-duration: 500ms;
}

.coupon-image:hover {
  width: 100%;
}

.coupon-image.active {
  width: 100%;
  outline: 5px solid #ffe300;
  outline-offset: 5px;
}

.coupons-ctr {
  gap: 15px;
  margin-block-end: 20px;
}
.coupon-image {
  width: 30%;
}

.coupon-ctr:hover {
  opacity: 0.6;
}
.coupon-ctr {
  padding-block: 0;
  width: 100%;
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  background-color: #f3f3f3;
  padding-inline: 3%;
}

.coupon-ctr.active {
  outline: 5px solid #ffe300;
  outline-offset: 4px;
}
.coupon-image:hover {
  width: 30%;
}

.coupon-image.active {
  width: 30%;
  border: none;
  outline: none;
}

.hdr-ctr {
  display: flex;

  align-items: center;
  justify-content: center;
}
</style>
